const request = require('request');
const config = require('./config');

const getURLFile = (token, query) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/preSignedUrl',
        qs: query,
        method: 'GET',
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
    });
  });
};

const getDownload = (query) => {
  return fetch(`${config.URL_BACKEND}/preSignedUrl/download?key=${query.key}&UserToken=${query.UserToken}`, {
    method: 'GET',
    headers: { "Content-Type": "application/json" },
  });
};

const get = (token, query) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/qualidade',
        method: 'GET',
        qs: query,
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
    });
  });
};

const getProdutos = (token, query) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/ficha-tecnica/ficha-alfa',
        method: 'GET',
        qs: query
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
    });
  });
};

const getSituacoes = (token) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/qualidade/situacoes',
        method: 'GET',
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
    });
  });
};

const putFileMoveis = (token,body,id) => {
  return new Promise((resolve,reject) => {
    const url = `${config.URL_BACKEND}/qualidade/moveis/${id}`;
    const response = fetch(url, {
      headers: {
        "User-Token": token
      },
      method: 'PUT',
      body: body
    });
    resolve(response);
  });
};

const postFileMoveis = (token,body) => {
  return new Promise((resolve,reject) => {
    const url = `${config.URL_BACKEND}/qualidade/moveis`;
    const response = fetch(url, {
      headers: {
        "User-Token": token
      },
      method: 'POST',
      body: body
    });
    resolve(response);
  });
};

const postFileAcessorios = (token,body) => {
  return new Promise((resolve,reject) => {
    const url = `${config.URL_BACKEND}/qualidade/acessorios`;
    const response = fetch(url, {
      headers: {
        "User-Token": token
      },
      method: 'POST',
      body: body
    });
    resolve(response);
  });
};

const getGrupos = ({ token, params }) => {
  return new Promise((resolve, reject) => {
      request(
          {
              headers: {
                  "Content-Type": "application/json",
                  "User-Token": token,
              },
              uri: `${config.URL_BACKEND}/qualidade/grupos`,
              method: "GET",
              qs: params,
          },
          (err, res, body) => {
              resolve({ err: err, res: res, body: body });
          }
      );
  });
};

const getFamilias = ({ token, params }) => {
  return new Promise((resolve, reject) => {
      request(
          {
              headers: {
                  "Content-Type": "application/json",
                  "User-Token": token,
              },
              uri: `${config.URL_BACKEND}/qualidade/familias`,
              method: "GET",
              qs: params,
          },
          (err, res, body) => {
              resolve({ err: err, res: res, body: body });
          }
      );
  });
};

module.exports = {
  get,
  getURLFile,
  postFileMoveis,
  postFileAcessorios,
  putFileMoveis,
  getProdutos,
  getSituacoes,
  getDownload,
  getGrupos,
  getFamilias,
}